import { clsx } from 'clsx'

import type { Video } from '~publish/legacy/composer/composer/entities/factories'

import { getOrientation, ImageOrientation } from '../../../Common/utils'
import { VideoPlayer as VideoPlayerCommon } from '../../../Common/VideoPlayer'

import styles from './VideoPlayer.module.css'

import type { JSX } from 'react'

interface VideoPlayerProps {
  video: Video
  variant?: 'post' | 'story'
}

const VideoPlayer = ({
  video,
  variant = 'post',
}: VideoPlayerProps): JSX.Element => {
  const { height, width } = video
  const orientation = getOrientation({ height, width })

  return (
    <VideoPlayerCommon
      video={video}
      showSoundOffIcon
      className={clsx(styles.videoPlayer, {
        [styles.portrait]: orientation === ImageOrientation.Portrait,
        [styles.landscape]: orientation === ImageOrientation.Landscape,
        [styles.story]: variant === 'story',
      })}
    />
  )
}

export { VideoPlayer }
